'use client';

import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import StatusBar from 'src/components/primitives/StatusBar/StatusBar';

const NewVersionBar = () => {
	const showNewVersionStatusBar = useDriftStore(
		(s) => s.statusBars?.showNewVersionStatusBar
	);

	if (!showNewVersionStatusBar) {
		return null;
	}

	return (
		<StatusBar variant="announcement">
			A new update is available. Refresh the app to get the latest improvements!
		</StatusBar>
	);
};

export default NewVersionBar;
